import * as React from 'react';
import React__default from 'react';
import { toast, Alert, Button } from '@grandvisionhq/common';
import { gql, useLazyQuery } from '@grandvisionhq/graphql';
import * as swcHelpers from '@swc/helpers';
import { Icon } from '@grandvisionhq/icons';
import { useFeatureToggles, useIntl } from '@grandvisionhq/state';
import { useDynamicModule, unspaceString } from '@grandvisionhq/utils';
import { Select, PhoneNumber } from '@grandvisionhq/forms';
import { useLink } from '@grandvisionhq/frk-routing';

const getBrandIcon = (brand)=>{
    switch(brand){
        case 'mc':
            return /*#__PURE__*/ React__default.createElement(Icon, {
                key: "mastercard",
                name: "mastercard",
                viewBox: "6 0 36 28",
                width: 36,
                height: 30
            });
        case 'amex':
            return /*#__PURE__*/ React__default.createElement(Icon, {
                key: "amex",
                name: "amex",
                viewBox: "0 0 40 24",
                width: 40,
                height: 24
            });
        case 'maestro':
            return /*#__PURE__*/ React__default.createElement(Icon, {
                key: "maestro",
                name: "maestro",
                viewBox: "6 0 36 28",
                width: 36,
                height: 30
            });
        case 'dankort':
            return /*#__PURE__*/ React__default.createElement(Icon, {
                key: "dankort",
                name: "dankort",
                viewBox: "0 0 39 19",
                width: 39,
                height: 19
            });
        case 'visa':
            return /*#__PURE__*/ React__default.createElement(Icon, {
                key: "visa",
                name: "visa",
                viewBox: "0 7 47 20",
                width: 47,
                height: 30
            });
        default:
            return undefined;
    }
};
const getCreditCardBrandsIcons = (brands)=>brands.reduce((acc, brand)=>[
            ...acc,
            getBrandIcon(brand)
        ]
    , [])
;

var AdyenPaymentType;
(function(AdyenPaymentType) {
    AdyenPaymentType["Card"] = 'card';
    AdyenPaymentType["Bancontact"] = 'bcmc';
    AdyenPaymentType["BancontactMobile"] = 'bancontactMobile';
    AdyenPaymentType["Sepa"] = 'sepadirectdebit';
    AdyenPaymentType["Swish"] = 'swish';
})(AdyenPaymentType || (AdyenPaymentType = {}));

var PaymentServiceProvider;
(function(PaymentServiceProvider) {
    PaymentServiceProvider["ADYEN"] = "ADYEN";
    PaymentServiceProvider["CASH_ON_DELIVERY"] = "CASH_ON_DELIVERY";
    PaymentServiceProvider["FAKE"] = "FAKE";
})(PaymentServiceProvider || (PaymentServiceProvider = {}));
var ExpressPaymentMethod;
(function(ExpressPaymentMethod) {
    ExpressPaymentMethod["APPLE_PAY"] = "APPLE_PAY";
    ExpressPaymentMethod["GOOGLE_PAY"] = "GOOGLE_PAY";
    ExpressPaymentMethod["AMAZON_PAY"] = "AMAZON_PAY";
})(ExpressPaymentMethod || (ExpressPaymentMethod = {}));
var PaymentMethod;
(function(PaymentMethod) {
    PaymentMethod["APPLE_PAY"] = "APPLE_PAY";
    PaymentMethod["BANCONTACT_CARD"] = "BANCONTACT_CARD";
    PaymentMethod["BANCONTACT_MOBILE"] = "BANCONTACT_MOBILE";
    PaymentMethod["CASH_ON_DELIVERY"] = "CASH_ON_DELIVERY";
    PaymentMethod["CREDITCARD"] = "CREDITCARD";
    PaymentMethod["FAKE"] = "FAKE";
    PaymentMethod["IDEAL"] = "IDEAL";
    PaymentMethod["KLARNA"] = "KLARNA";
    PaymentMethod["KLARNA_ACCOUNT"] = "KLARNA_ACCOUNT";
    PaymentMethod["MBWAY"] = "MBWAY";
    PaymentMethod["MOBILE_PAY"] = "MOBILE_PAY";
    PaymentMethod["MULTIBANCO"] = "MULTIBANCO";
    PaymentMethod["ONEY"] = "ONEY";
    PaymentMethod["PAYPAL"] = "PAYPAL";
    PaymentMethod["SEPA_DIRECT_DEBIT"] = "SEPA_DIRECT_DEBIT";
    PaymentMethod["SWISH"] = "SWISH";
})(PaymentMethod || (PaymentMethod = {}));
var AdyenBrands;
(function(AdyenBrands) {
    AdyenBrands["VISA"] = 'visa';
    AdyenBrands["MASTERCARD"] = 'mc';
    AdyenBrands["AMEX"] = 'amex';
    AdyenBrands["BANCONTACTMC"] = 'bcmc';
    AdyenBrands["MAESTRO"] = 'maestro';
})(AdyenBrands || (AdyenBrands = {}));

const getPaymentMethodIcon = (method)=>{
    switch(method){
        case PaymentMethod.BANCONTACT_CARD:
        case PaymentMethod.BANCONTACT_MOBILE:
            return [
                /*#__PURE__*/ React__default.createElement(Icon, {
                    key: "bancontact",
                    name: "bancontact",
                    width: 53,
                    height: 33,
                    viewBox: "-8 0 53 33"
                }), 
            ];
        case PaymentMethod.CASH_ON_DELIVERY:
            return [
                /*#__PURE__*/ React__default.createElement(Icon, {
                    key: "cashOnDelivery",
                    name: "cash-on-delivery"
                })
            ];
        case PaymentMethod.IDEAL:
            return [
                /*#__PURE__*/ React__default.createElement(Icon, {
                    key: "ideal",
                    name: "ideal",
                    viewBox: "0 0 26 23",
                    width: 26,
                    height: 23
                })
            ];
        case PaymentMethod.KLARNA:
        case PaymentMethod.KLARNA_ACCOUNT:
            return [
                /*#__PURE__*/ React__default.createElement(Icon, {
                    key: "klarna",
                    name: "klarna",
                    viewBox: "0 0 45 25",
                    width: 60,
                    height: 33
                })
            ];
        case PaymentMethod.MBWAY:
            return [
                /*#__PURE__*/ React__default.createElement(Icon, {
                    key: "mbway",
                    name: "mbway",
                    viewBox: "18 0 54 48",
                    width: 60,
                    height: 48
                })
            ];
        case PaymentMethod.MOBILE_PAY:
            return [
                /*#__PURE__*/ React__default.createElement(Icon, {
                    key: "mobilepay",
                    name: "mobilepay",
                    viewBox: "0 0 40 26",
                    width: 40,
                    height: 26
                })
            ];
        case PaymentMethod.MULTIBANCO:
            return [
                /*#__PURE__*/ React__default.createElement(Icon, {
                    key: "multibanco",
                    name: "multibanco",
                    viewBox: "-24 0 56 64",
                    width: 56,
                    height: 64
                }), 
            ];
        case PaymentMethod.ONEY:
            return [
                /*#__PURE__*/ React__default.createElement(Icon, {
                    key: "oney",
                    name: "oney",
                    viewBox: "0 0 113.5 36.5",
                    width: 32,
                    height: 24
                })
            ];
        case PaymentMethod.PAYPAL:
            return [
                /*#__PURE__*/ React__default.createElement(Icon, {
                    key: "paypal",
                    name: "paypal",
                    viewBox: "-2 4 48 16",
                    width: 48,
                    height: 24
                })
            ];
        case PaymentMethod.SEPA_DIRECT_DEBIT:
            return [
                /*#__PURE__*/ React__default.createElement(Icon, {
                    key: "sepa",
                    name: "sepa",
                    viewBox: "0 0 32 24",
                    width: 32,
                    height: 24
                })
            ];
        case PaymentMethod.SWISH:
            return [
                /*#__PURE__*/ React__default.createElement(Icon, {
                    key: "swish",
                    name: "swish",
                    viewBox: "10 0 70 34",
                    width: 70,
                    height: 40
                })
            ];
        default:
            return undefined;
    }
};

const cartPaymentMethods = ({ cartPaymentMethods: cartPaymentMethods1  })=>{
    var ref;
    return (ref = cartPaymentMethods1 || []) === null || ref === void 0 ? void 0 : ref.map(({ name: name1 , psp , issuers , brands , installmentTypes  })=>{
        const icons = (brands === null || brands === void 0 ? void 0 : brands.length) ? getCreditCardBrandsIcons(brands) : getPaymentMethodIcon(name1);
        return swcHelpers.objectSpread({
            name: name1,
            provider: psp
        }, (icons === null || icons === void 0 ? void 0 : icons.length) && {
            icons
        }, (issuers === null || issuers === void 0 ? void 0 : issuers.length) && {
            items: issuers.map(({ id , name  })=>({
                    key: id,
                    value: name
                })
            )
        }, (brands === null || brands === void 0 ? void 0 : brands.length) && {
            brands
        }, (installmentTypes === null || installmentTypes === void 0 ? void 0 : installmentTypes.length) && {
            items: installmentTypes.map(({ id , installments  })=>({
                    key: id,
                    value: String(installments)
                })
            )
        });
    });
};

const errorsMapping = {
    SOMETHING_WENT_WRONG: 'errors.somethingWentWrong'
};

const GET_CART_PAYMENT_METHODS = gql`
  query CartPaymentMethods($cartId: ID!) {
    cartPaymentMethods(cartId: $cartId) {
      psp
      name
      issuers {
        id
        name
      }
      brands
      installmentTypes {
        id
        installments
      }
    }
  }
`;

const useGetCartPaymentMethods = ()=>{
    const [getCartPaymentMethods, { called , loading , data , error: error1  }] = useLazyQuery(GET_CART_PAYMENT_METHODS, {
        onError (error) {
            console.error(error);
            // General error for apollo error response
            toast.failed(errorsMapping.SOMETHING_WENT_WRONG);
        }
    });
    const getPaymentMethods = React.useCallback((cartId)=>{
        if (cartId) {
            getCartPaymentMethods({
                variables: {
                    cartId
                }
            });
        }
    }, [
        getCartPaymentMethods
    ]);
    const queryResults = React.useMemo(()=>({
            data: data ? cartPaymentMethods(data) : undefined,
            called,
            loading,
            error: error1
        })
    , [
        called,
        data,
        error1,
        loading
    ]);
    return [
        getPaymentMethods,
        queryResults
    ];
};

const useIsApplePayActive = ()=>{
    const { isApplePayExpressCheckoutEnabled  } = useFeatureToggles();
    const isApplePayActive = isApplePayExpressCheckoutEnabled && typeof ApplePaySession !== 'undefined' && (ApplePaySession === null || ApplePaySession === void 0 ? void 0 : ApplePaySession.canMakePayments);
    return {
        isApplePayActive
    };
};

const AdyenContext = /*#__PURE__*/ React.createContext({
    clientKey: '',
    environment: 'test',
    AdyenModule: {
        result: undefined,
        loading: true
    }
});
const useAdyen = ()=>React.useContext(AdyenContext)
;
const AdyenProvider = ({ children , settings  })=>{
    // The `@adyen/adyen-web` package uses a hard reference to the global `window` variable. This makes it
    // impossible to import the package in a normal manner. Hence the choice to use dynamic importing.
    const [result, loading] = useDynamicModule(swcHelpers.asyncToGenerator(function*() {
        if (typeof window !== 'undefined') {
            return yield import('@adyen/adyen-web').then((module)=>module.default
            );
        }
        return undefined;
    }), '@adyen/adyen-web', []);
    const memoizedSettings = React.useMemo(()=>swcHelpers.objectSpread({}, settings, {
            AdyenModule: {
                result: result !== null && result !== void 0 ? result : undefined,
                loading
            }
        })
    , [
        settings,
        loading,
        result
    ]);
    return /*#__PURE__*/ React.createElement(AdyenContext.Provider, {
        value: memoizedSettings
    }, children);
};

function useCheckout(onChange) {
    const { locale  } = useIntl();
    // Import the adyen web module
    const { AdyenModule , clientKey , environment  } = useAdyen();
    const options = React.useMemo(()=>({
            clientKey,
            environment,
            locale: `${locale}`,
            onChange
        })
    , [
        clientKey,
        environment,
        locale,
        onChange
    ]);
    // The checkout object is local to the current page, it needs to be memoized
    // so to handle the dynamic module loading correctly
    const checkout = React.useMemo(()=>{
        const AdyenCheckout = AdyenModule === null || AdyenModule === void 0 ? void 0 : AdyenModule.result;
        return AdyenCheckout && AdyenCheckout(options);
    }, [
        AdyenModule,
        options
    ]);
    return checkout;
}

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  useGetCartPaymentMethods: useGetCartPaymentMethods,
  useIsApplePayActive: useIsApplePayActive,
  useCheckout: useCheckout
});

const PaymentMethodFormContainer = ({ children , type , additionalOptions , checkout ,  })=>{
    const ref = React.useRef(null);
    // In order to properly unmount any mounted elements, the promise of the mounted element is used to
    // properly unmount it again whenever the cleanup cycle is triggered.
    React.useEffect(()=>{
        if (!checkout) return;
        const mountPayment = function() {
            var _ref = swcHelpers.asyncToGenerator(function*() {
                const c = yield checkout;
                const paymentMethod = c === null || c === void 0 ? void 0 : c.create(type, additionalOptions);
                var _current;
                return paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.mount((_current = ref.current) !== null && _current !== void 0 ? _current : '');
            });
            return function mountPayment() {
                return _ref.apply(this, arguments);
            };
        }();
        const promise = mountPayment();
        return ()=>{
            promise.then((component)=>{
                return component === null || component === void 0 ? void 0 : component.unmount();
            });
        };
    }, [
        type,
        additionalOptions,
        checkout
    ]);
    if (!checkout) return null;
    return /*#__PURE__*/ React.createElement("div", {
        ref: ref,
        className: "adyen-payment-method-form"
    }, children);
};

const PaymentMethodForm = (props)=>/*#__PURE__*/ React.createElement(PaymentMethodFormContainer, swcHelpers.extends({}, props))
;

var ref, ref1, ref2, ref3, ref4;
const toPaymentMethodFormState$1 = (state, cardBrand)=>{
    var ref18, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17;
    return {
        cardBrand,
        isValid: state.isValid,
        data: {
            browserInfo: {
                acceptHeader: state === null || state === void 0 ? void 0 : (ref18 = state.data) === null || ref18 === void 0 ? void 0 : (ref5 = ref18.browserInfo) === null || ref5 === void 0 ? void 0 : ref5.acceptHeader,
                userAgent: state === null || state === void 0 ? void 0 : (ref6 = state.data) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.browserInfo) === null || ref7 === void 0 ? void 0 : ref7.userAgent
            },
            holderName: (ref = state === null || state === void 0 ? void 0 : (ref8 = state.data) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.paymentMethod) === null || ref9 === void 0 ? void 0 : ref9.holderName) !== null && ref !== void 0 ? ref : '',
            encryptedCardNumber: (ref1 = state === null || state === void 0 ? void 0 : (ref10 = state.data) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.paymentMethod) === null || ref11 === void 0 ? void 0 : ref11.encryptedCardNumber) !== null && ref1 !== void 0 ? ref1 : '',
            encryptedExpiryMonth: (ref2 = state === null || state === void 0 ? void 0 : (ref12 = state.data) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.paymentMethod) === null || ref13 === void 0 ? void 0 : ref13.encryptedExpiryMonth) !== null && ref2 !== void 0 ? ref2 : '',
            encryptedExpiryYear: (ref3 = state === null || state === void 0 ? void 0 : (ref14 = state.data) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.paymentMethod) === null || ref15 === void 0 ? void 0 : ref15.encryptedExpiryYear) !== null && ref3 !== void 0 ? ref3 : '',
            encryptedSecurityCode: (ref4 = state === null || state === void 0 ? void 0 : (ref16 = state.data) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.paymentMethod) === null || ref17 === void 0 ? void 0 : ref17.encryptedSecurityCode) !== null && ref4 !== void 0 ? ref4 : ''
        }
    };
};
const CreditCardContainer = ({ onChange , additionalOptions , type =AdyenPaymentType.Card ,  })=>{
    const [state, setState] = React.useState();
    const [brand, setBrand] = React.useState();
    const checkout = useCheckout(setState);
    const additional = React.useMemo(()=>{
        return swcHelpers.objectSpread({
            hasHolderName: true,
            holderNameRequired: true
        }, additionalOptions, {
            onBrand: (obj)=>{
                var ref19;
                additionalOptions === null || additionalOptions === void 0 ? void 0 : (ref19 = additionalOptions.onBrand) === null || ref19 === void 0 ? void 0 : ref19.call(additionalOptions, obj);
                setBrand(obj.brand);
            }
        });
    }, [
        additionalOptions,
        setBrand
    ]);
    React.useEffect(()=>{
        if (state) {
            onChange(toPaymentMethodFormState$1(state, brand));
        }
    }, [
        brand,
        state,
        onChange
    ]);
    return /*#__PURE__*/ React.createElement(PaymentMethodForm, {
        type: type,
        checkout: checkout,
        additionalOptions: additional
    });
};

const CreditCard = (props)=>/*#__PURE__*/ React.createElement(CreditCardContainer, swcHelpers.extends({}, props))
;

const IdealContainer = ({ items , onChange  })=>{
    const { getLabel  } = useIntl();
    const labels = React.useMemo(()=>({
            title: getLabel('checkout.payment.method.ideal.select.title')
        })
    , [
        getLabel
    ]);
    return /*#__PURE__*/ React.createElement(Select, {
        id: "idealBankSelect",
        name: "idealBankSelect",
        options: items,
        onChange: onChange,
        label: labels.title,
        placeholder: labels.title
    });
};

const Ideal = (props)=>/*#__PURE__*/ React.createElement(IdealContainer, swcHelpers.extends({}, props))
;

const Mbway$1 = ({ initialValue , labels , onChange , validations  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: "mbway-payment checkout-payment-wrapper"
    }, /*#__PURE__*/ React.createElement(Alert, {
        className: "mbway-payment__alert",
        title: labels.hintTitle,
        message: labels.hintMessage
    }), /*#__PURE__*/ React.createElement(PhoneNumber, {
        initialState: {
            value: initialValue,
            isTouched: false
        },
        required: true,
        onChange: onChange,
        validations: validations,
        label: labels.phoneNumberLabel,
        placeholder: labels.phoneNumberPlaceholder,
        errorMessage: labels.phoneNumberError
    }));
};

const isValidPortugueseMobilePhoneNumber = (value)=>/^(\+351|00351|351)([9]{1})(6|3|2|1{1})([0-9]{7})$/.test(unspaceString(value))
;

const MbwayContainer = ({ initialValue , onChange  })=>{
    const { getLabel  } = useIntl();
    const handleOnChange = React.useCallback((state)=>{
        onChange({
            telephoneNumber: unspaceString(state.value)
        }, isValidPortugueseMobilePhoneNumber(state.value));
    }, [
        onChange
    ]);
    const labels = React.useMemo(()=>{
        return {
            hintTitle: getLabel('checkout.payment.method.mbWay.hint.title'),
            hintMessage: getLabel('checkout.payment.method.mbWay.hint.message'),
            phoneNumberLabel: getLabel('checkout.contact.phoneNumber'),
            phoneNumberPlaceholder: getLabel('checkout.payment.method.mbWay.phoneNumber.placeholder'),
            phoneNumberError: getLabel('checkout.contact.phoneNumber.errorMessage')
        };
    }, [
        getLabel
    ]);
    return /*#__PURE__*/ React.createElement(Mbway$1, {
        initialValue: initialValue,
        labels: labels,
        onChange: handleOnChange,
        validations: [
            isValidPortugueseMobilePhoneNumber
        ]
    });
};

const Mbway = (props)=>/*#__PURE__*/ React.createElement(MbwayContainer, swcHelpers.extends({}, props))
;

const Oney$1 = ({ options , labels , onChange  })=>/*#__PURE__*/ React.createElement(Select, {
        id: "oneyInstallments",
        name: "oneyInstallments",
        options: options,
        onChange: onChange,
        label: labels.title,
        placeholder: labels.placeholder,
        required: true
    })
;

const OneyContainer = ({ onChange , options  })=>{
    const { getLabel  } = useIntl();
    const labels = React.useMemo(()=>({
            title: getLabel('checkout.payment.method.oney.select.title'),
            placeholder: getLabel('checkout.payment.method.oney.select.placeholder')
        })
    , [
        getLabel
    ]);
    return /*#__PURE__*/ React.createElement(Oney$1, {
        labels: labels,
        onChange: onChange,
        options: options
    });
};

const Oney = (props)=>/*#__PURE__*/ React.createElement(OneyContainer, swcHelpers.extends({}, props))
;

// This component will create any Adyen web component that can be created from it's "action" prop.
//
// NOTE:
// currently only tested with the "redirect" action
const ActionContainer = ({ action  })=>{
    const ref = React.useRef(null);
    const checkout = useCheckout();
    // Mounts the action component if we receive an action from adyen
    React.useEffect(()=>{
        if (!checkout || !action) return;
        const mountAction = function() {
            var _ref = swcHelpers.asyncToGenerator(function*() {
                const c = yield checkout;
                const actionComponent = c === null || c === void 0 ? void 0 : c.createFromAction(action);
                var _current;
                return actionComponent === null || actionComponent === void 0 ? void 0 : actionComponent.mount((_current = ref.current) !== null && _current !== void 0 ? _current : '');
            });
            return function mountAction() {
                return _ref.apply(this, arguments);
            };
        }();
        const promise = mountAction();
        return ()=>{
            promise.then((component)=>{
                return component === null || component === void 0 ? void 0 : component.unmount();
            });
        };
    }, [
        checkout,
        action
    ]);
    if (!action) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        ref: ref,
        className: "adyen-action-component"
    });
};

var _ownerName, _iban;
const toPaymentMethodFormState = (state)=>({
        isValid: state.isValid,
        data: {
            'sepa.ownerName': (_ownerName = state.data.paymentMethod.ownerName) !== null && _ownerName !== void 0 ? _ownerName : '',
            'sepa.ibanNumber': (_iban = state.data.paymentMethod.iban) !== null && _iban !== void 0 ? _iban : ''
        }
    })
;
const SepaContainer = ({ onChange  })=>{
    const setSepaState = React.useCallback((state)=>onChange(toPaymentMethodFormState(state))
    , [
        onChange, 
    ]);
    const checkout = useCheckout(setSepaState);
    return /*#__PURE__*/ React.createElement(PaymentMethodForm, {
        type: AdyenPaymentType.Sepa,
        checkout: checkout
    });
};

const Sepa = (props)=>/*#__PURE__*/ React.createElement(SepaContainer, swcHelpers.extends({}, props))
;

const ApplePayCaption = ({ type  })=>{
    const { getLabel  } = useIntl();
    let descriptionText;
    switch(type){
        case 'navigate-to-express-checkout':
            descriptionText = getLabel('checkout.express.apple.pay.action.continue');
            break;
        case 'express-checkout':
            descriptionText = getLabel('checkout.express.apple.pay.action.checkout');
    }
    return /*#__PURE__*/ React.createElement("span", {
        className: "apple-pay-caption"
    }, descriptionText, /*#__PURE__*/ React.createElement(Icon, {
        color: "white",
        name: "apple"
    }), getLabel('checkout.express.apple.pay.action.pay'));
};
const BuildFE2FrameworkUnavailableFallback = (props)=>{
    if ((props === null || props === void 0 ? void 0 : props.type) === 'navigate-to-express-checkout') {
        let fallBackUrl = `/express-checkout?type=APPLE_PAY&returnPath=%2Fcart`;
        if (!!props.cartId) fallBackUrl += `&cartId=${props.cartId}`;
        return fallBackUrl;
    }
    return undefined;
};
const ApplePayButton = (props)=>{
    const cartLink = useLink({
        route: 'cart.overview'
    });
    const expressCheckoutLink = useLink({
        route: 'express-checkout',
        params: swcHelpers.objectSpread({
            type: ExpressPaymentMethod.APPLE_PAY,
            returnPath: cartLink === null || cartLink === void 0 ? void 0 : cartLink.href
        }, (props === null || props === void 0 ? void 0 : props.type) === 'navigate-to-express-checkout' ? {
            cartId: props === null || props === void 0 ? void 0 : props.cartId
        } : {})
    });
    const caption = /*#__PURE__*/ React.createElement(ApplePayCaption, {
        type: props.type
    });
    return /*#__PURE__*/ React.createElement(Button, {
        className: "cart-navigation__button apple-pay",
        "data-t": props.type,
        caption: caption,
        href: props.type === 'navigate-to-express-checkout' && ((expressCheckoutLink === null || expressCheckoutLink === void 0 ? void 0 : expressCheckoutLink.href) || BuildFE2FrameworkUnavailableFallback(props)) || '',
        onClick: props.type === 'express-checkout' && props.onClick || undefined
    });
};
const ApplePayCheckoutButton = (props)=>{
    const { isApplePayActive  } = useIsApplePayActive();
    if (!isApplePayActive) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(ApplePayButton, swcHelpers.extends({}, props));
};

export { ActionContainer, AdyenBrands, AdyenPaymentType, AdyenProvider, ApplePayCheckoutButton, CreditCard, ExpressPaymentMethod, index as Hooks, Ideal, Mbway, Oney, PaymentMethod, PaymentMethodForm, PaymentServiceProvider, Sepa, useAdyen };
//# sourceMappingURL=index.js.map
